import React from 'react'
import './index.less'
let index = 0

class Broadcast extends React.Component {
    constructor () {
        super()
        this.timer = null
        this.state = ({
            isPlayer: false
        })
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.broadcastList.length > 6 && !this.state.isPlayer) {
            this.setState({
                isPlayer: true
            })
        } else {
            this.setState({
                isPlayer: false
            })
        }
    }

    componentDidUpdate () {
        const { isPlayer } = this.state
        if (isPlayer && !this.timer) {
            this.player()
        }
    }

    componentWillUnmount () {
        clearInterval(this.timer)
    }

    // 处理时间数据 12:01:33
    handleTime = (data) => {
        const time = data.split(' ')[1]
        return time
    }

    player = () => {
        const me = this
        ++index
        const broadcastItemBox = document.getElementById('broadcastItemBox')
        const broadcastBox = document.getElementById('broadcastBox')
        if (broadcastItemBox) {
            const broadcastItemBoxMarginTop = parseInt(broadcastItemBox.style.marginTop)
            this.timer = setInterval(() => {
                if (broadcastItemBox.offsetHeight + broadcastItemBoxMarginTop > broadcastBox.offsetHeight) {
                    broadcastItemBox.style.marginTop = -index * 30 + 'px'
                } else {
                    broadcastItemBox.style.marginTop = 0 + 'px'
                    index = 0
                }
                clearInterval(this.timer)
                me.player()
            }, 1000)
        } else {
            clearInterval(this.timer)
            this.timer = null
        }
    }

    render () {
        const { broadcastList, activitySliderList, data: { style } } = this.props
        return (
            <div className={'broadcastContainer'} style={{ marginTop: `${style.paddingTop / 75}rem` || 0 }}>
                <p>
                    <i className={'broadcastIcon'}></i>
                    <span>投资播报</span>
                </p>
                <div className={'broadcastItemContainer'} >
                    <div id={'broadcastBox'}>
                        {activitySliderList[0].venueStatus === 1 && <p>敬请期待</p>}
                        {activitySliderList[activitySliderList.length - 1].venueStatus === 3 && <p>活动已结束</p>}
                        {broadcastList.length > 6 && activitySliderList[activitySliderList.length - 1].venueStatus !== 3 && <ul id={'broadcastItemBox'}>
                            {
                                broadcastList.map((item, index) => {
                                    return (
                                        <li key={index}>
                                            <span>{this.handleTime(item.tradeTime)}</span>
                                            <span>用户{item.mobile}</span>
                                            <span>成功投资<i>{item.tradeAmount}元</i></span>
                                        </li>
                                    )
                                })
                            }
                            {
                                broadcastList.map((item, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            {index === 0 && <li>
                                                <span>{this.handleTime(item.tradeTime)}</span>
                                                <span>用户{item.mobile}</span>
                                                <span>成功投资<i>{item.tradeAmount}元</i></span>
                                            </li>}
                                            {index === 1 && <li>
                                                <span>{this.handleTime(item.tradeTime)}</span>
                                                <span>用户{item.mobile}</span>
                                                <span>成功投资<i>{item.tradeAmount}元</i></span>
                                            </li>}
                                            {index === 2 && <li>
                                                <span>{this.handleTime(item.tradeTime)}</span>
                                                <span>用户{item.mobile}</span>
                                                <span>成功投资<i>{item.tradeAmount}元</i></span>
                                            </li>}
                                            {index === 3 && <li>
                                                <span>{this.handleTime(item.tradeTime)}</span>
                                                <span>用户{item.mobile}</span>
                                                <span>成功投资<i>{item.tradeAmount}元</i></span>
                                            </li>}
                                            {index === 4 && <li>
                                                <span>{this.handleTime(item.tradeTime)}</span>
                                                <span>用户{item.mobile}</span>
                                                <span>成功投资<i>{item.tradeAmount}元</i></span>
                                            </li>}
                                        </React.Fragment>
                                    )
                                })
                            }
                        </ul>}
                        {broadcastList.length && broadcastList.length <= 6 &&
                            activitySliderList[activitySliderList.length - 1].venueStatus !== 3 && (
                            <ul>
                                {
                                    broadcastList.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{this.handleTime(item.tradeTime)}</span>
                                                <span>用户{item.mobile}</span>
                                                <span>成功投资<i>{item.tradeAmount}元</i></span>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        )}

                    </div>
                </div>

            </div>
        )
    }
}

export default Broadcast
